<template>
  <div
    v-if="type_object === 'message'"
    class="neoron-options-render outgoing-chats"
  >
    <div v-html="sanitizeHTML(message)" class="msg-render-chat"></div>
  </div>
  <div
    :class="
      ['neoron-options-render list-btn-option', getButtonLayout()].join(' ')
    "
    v-else-if="type_object === 'button'"
  >
    <div
      class="buttons-default-layout"
      v-if="
        settings.button_layout === 'horizontal' ||
        settings.button_layout === 'vertical'
      "
    >
      <div class="box-btn" v-for="button in buttons.content" :key="button.id">
        <a v-if="button.url" :href="button.url" target="_blank">
          <button
            class="option-btn"
            @click="sendDirect(button.idCard, button.value, button.key)"
          >
            {{ button.value }}
          </button>
        </a>
        <button
          v-if="!button.url"
          class="option-btn"
          @click="sendDirect(button.idCard, button.value, button.key)"
        >
          {{ button.value }}
        </button>
      </div>
    </div>
    <div
      class="buttons-select-layout"
      v-else-if="settings.button_layout === 'select'"
    >
      <a-select
        show-search
        option-filter-prop="children"
        default-value=""
        style="width: 100%"
        @change="handleChangeButtonSelect"
        :getPopupContainer="triggerParentNode"
      >
        <a-select-option value="" disabled>
          Selecione uma opção
        </a-select-option>
        <a-select-option
          :value="index"
          v-for="(button, index) in buttons.content"
          :key="button.id"
        >
          {{ button.value }}
        </a-select-option>
      </a-select>
    </div>

    <div
      class="buttons-select-layout"
      v-else-if="settings.button_layout === 'multiple_select'"
    >
      <a-select
        mode="multiple"
        :size="size"
        placeholder="Selecione as opções"
        :default-value="[]"
        style="width: 75%"
        @change="handleChangeButtonMultipleSelect"
        :getPopupContainer="triggerParentNode"
      >
        <a-select-option
          :value="index"
          v-for="(button, index) in buttons.content"
          :key="button.id"
        >
          {{ button.value }}
        </a-select-option>
      </a-select>
      <button class="send-selected" @click="sendMultipleSelected">
        enviar
      </button>
    </div>
  </div>
  <div
    v-else-if="type_object === 'capture_carousel'"
    class="neoron-options-render"
  >
    <splide :options="carouselOptions" class="splide-content">
      <splide-slide
        v-for="(slide, index) in content.object.content.cards"
        :key="index"
        class="card-splide"
      >
        <div class="img-box">
          <img class="img-card" :src="slide.photo" alt="opção" />
          <div
            class="select-img"
            @click="
              () => {
                visibleCar = true;
                imgPreview = slide.photo;
              }
            "
          >
            Ver detalhes
          </div>
        </div>
        <div
          class="content"
          :style="
            slide.directToCardEnable
              ? { borderBottom: '1px solid #b9b8b88a' }
              : {}
          "
        >
          <h5 class="title" v-if="slide.titleEnable">
            {{ slide.title }}
          </h5>
          <p class="description" v-if="slide.descriptionEnable">
            {{ slide.description }}
          </p>
        </div>
        <a
          v-if="slide.linkValue"
          :href="slide.linkValue"
          class="select"
          target="_blank"
          @click="sendCarosuel(slide, content.object)"
          >selecionar</a
        >
        <button
          class="select"
          @click="sendCarosuel(slide, content.object)"
          v-if="slide.directToCardEnable && !slide.linkValue"
        >
          selecionar
        </button>
      </splide-slide>
    </splide>
    <a-modal v-model="visibleCar" :footer="null">
      <img :src="imgPreview" alt="img" style="width: 100%" />
    </a-modal>
  </div>

  <div v-else-if="type_object === 'form'">
    <a-modal
      :visible="showFormModal"
      :width="channel === 'widget' ? '100%' : '450px'"
      id="modal-form"
      :closable="false"
      :maskClosable="false"
      v-if="content.object.content"
    >
      <template slot="title">
        <div class="title-modal">
          <div class="title-box">
            <a-icon type="profile" />
            <p>{{ content.object.content.titleForm }}</p>
          </div>

          <a-popover title="Descrição" :getPopupContainer="triggerParentNode">
            <template slot="content">
              {{ descriptionModal }}
            </template>

            <a-icon type="info-circle" />
          </a-popover>
        </div>
      </template>

      <div>
        <div
          class="list-fields"
          v-for="(field, index_field) in content.object.content.fields"
          :key="index_field"
        >
          <div>
            <template v-if="field.fieldType != 'checkbox'">
              <input
                :type="field.encript ? 'password' : 'text'"
                class="value-text"
                :name="'button_' + index_field"
                :id="'button_' + index_field"
                :placeholder="field.nameField"
                @input="changeInputForm($event, field.variableToCheck)"
              />
              <small
                class="required-hint"
                v-if="field.requiredField && !fields[field.variableToCheck]"
                >O campo {{ field.nameField }} é obrigatório!</small
              >
            </template>
            <template v-else-if="field.fieldType == 'checkbox'">
              <a-checkbox
                class="checkbox-form"
                @change="changeCheckBoxInForm(field.variableToCheck)"
              >
                <p v-html="sanitizeHTML(renderMarkdown(index_field))"></p>
              </a-checkbox>
              <small
                class="required-hint"
                v-if="field.requiredField && !fields[field.variableToCheck]"
                >Para prosseguir é necessário marcar a opção acima</small
              >
            </template>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div
          class="list-action-buttons"
          v-for="(actionButton, index_button) in content.object.content
            .actionsButtons"
          :key="index_button"
        >
          <button
            :disabled="actionButton.disable_require && !filledFields"
            @click="
              sendDirect(
                actionButton.card_id,
                actionButton.label,
                index_button,
                actionButton.is_auth_action
              )
            "
            :class="
              checkDisabled(actionButton.disable_require)
                ? 'btn-action'
                : 'btn-disabled'
            "
          >
            {{ actionButton.label }}
          </button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import "@splidejs/splide/dist/css/splide.min.css";
import "@splidejs/splide/dist/css/splide-core.min.css";
import DOMPurify from "dompurify";

import { Modal, Select, Popover, Icon, Checkbox } from "ant-design-vue";

export default {
  props: {
    content: {
      type: Object,
      required: true,
    },
    showFormModal: {
      type: Boolean,
      required: false,
    },
    channel: {
      type: String,
      default: "landing",
    },
  },
  components: {
    SplideSlide,
    Splide,
    AModal: Modal,
    ASelect: Select,
    ACheckbox: Checkbox,
    APopover: Popover,
    AIcon: Icon,
    ASelectOption: Select.Option,
  },

  data() {
    return {
      message: this.content.object.content,
      buttons: this.content.object,
      settings: this.content.object.settings ?? { button_layout: "horizontal" },
      size: "default",
      multiplesSelected: {},
      carouselOptions: {
        rewind: true,
        type: "slide",
        width: "100%",
        focus: "center",
        gap: "0.5rem",
        breakpoints: {
          640: {
            perPage: 2,
            gap: "1rem",
          },
          480: {
            perPage: 1,
            gap: "1rem",
          },
        },
      },
      filledFields: true,
      descriptionModal: "",
      fields: {},
      visibleCar: false,
      imgPreview: "",
    };
  },

  mounted() {
    this.direct = false;
    if (this.content.object.type === "form") {
      this.content.object.content.fields.map((item) => {
        if (item.fieldType === "checkbox") {
          this.fields[item.variableToCheck] = false;
        } else {
          this.fields[item.variableToCheck] = "";
        }
      });

      this.descriptionModal = this.content.object.content.description
        .replace("<p>", "")
        .replace("</p>", "");
    }

    this.checkRequiredFields();
  },

  computed: {
    type_object() {
      var type = this.content.object.type;
      return type;
    },
  },

  methods: {
    sanitizeHTML(data){
      return DOMPurify.sanitize(data);
    },
    
    triggerParentNode(parentNode) {
      return parentNode;
    },

    checkDisabled(required) {
      return required ? this.filledFields : true;
    },

    checkRequiredFields() {
      if (this.content.object.content.fields) {
        this.filledFields = true;
        this.content.object.content.fields.map((item) => {
          if (item.requiredField) {
            if (
              item.fieldType === "checkbox" &&
              this.fields[item.variableToCheck] == false
            ) {
              this.filledFields = false;
              return;
            }

            if (
              item.fieldType != "checkbox" &&
              this.fields[item.variableToCheck] == ""
            ) {
              this.filledFields = false;
              return;
            }
          }
        });
      }
    },

    changeCheckBoxInForm(index) {
      this.fields[index] = !this.fields[index];
      this.checkRequiredFields();
    },

    changeInputForm(event, index) {
      this.fields[index] = event.target.value;
      this.checkRequiredFields();
    },

    renderMarkdown(index) {
      const markdownConverted = this.content.object.content.fields[
        index
      ].nameField.replace(
        /\[([^\]]+)\]\(([^)]+)\)/,
        '<a href="$2" target="_blank">$1</a>'
      );

      return markdownConverted;
    },

    // renderComponent() {}
    sendDirect(idCard, value, buttonID, is_auth_action) {
      this.$emit("formModal", false);
      this.$emit("direct", {
        idCard,
        value,
        buttonID,
        form_data: this.fields,
        form_settings: {
          is_auth_action,
          fail_action: this.content.object.content,
        },
      });
    },

    getButtonLayout() {
      return this.content.object.settings &&
        this.content.object.settings.button_layout
        ? this.content.object.settings.button_layout
        : "horizontal";
    },

    handleChangeButtonSelect(value) {
      let button = this.buttons.content[value];
      setTimeout(() => {
        this.sendDirect(button.idCard, button.value, button.key);
      }, 500);
    },

    handleChangeButtonMultipleSelect(value) {
      let buttons = this.buttons.content.filter((_, index) =>
        value.includes(index)
      );
      this.multiplesSelected.buttons = buttons.map((item) => {
        return item.value;
      });
      this.multiplesSelected.idCard = this.buttons.content[0].idCard;
    },

    sendMultipleSelected() {
      let buttons = this.multiplesSelected;
      this.sendDirect(
        buttons.idCard,
        buttons.buttons.join(", "),
        (buttons.key = Date.now())
      );
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    sendCarosuel(option) {
      if (option.directToCardEnable) {
        let value =
          option.photo != null
            ? option.photo
            : option.descriptionEnable
            ? option.description
            : option.titleEnable
            ? option.title
            : "opção selecionada";
        this.$emit("carousel", {
          ...option,
          value,
          isImg: option.photo != null,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.title-modal {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#neoronChat-component {
  .neoron-options-render.outgoing-chats {
    text-align: left;
    margin: 5px 4px 6px 25px;
    background: #f1f1f1;
    border-radius: 8px;
    border-top-left-radius: 0%;
    padding: 0.5rem 0.8rem 0.2rem;
    max-width: 75%;
    word-break: break-word;
    box-shadow: 0px 1px 4px 0px #b1b1b173;
  }

  .neoron-options-render.list-btn-option {
    min-height: 48px;
    margin: 5px 4px 6px -2px;
    padding: 0 0 5px 0;

    &.vertical {
      .buttons-default-layout {
        flex-direction: column;
      }
    }

    .buttons-default-layout {
      display: flex;
      flex-wrap: wrap;
    }

    &.horizontal {
      .buttons-default-layout {
        .box-btn {
          flex: 45%;
        }
      }
    }

    .box-btn {
      margin: 5px;

      .option-btn {
        background: #ffffffa3 !important;
        margin-right: 10px !important;
        margin-bottom: 10px !important;
        border-radius: 6px !important;
        font-size: 16px !important;
        padding: 0.7rem !important;
        color: #292a2b !important;
        border: 0.05rem solid #292a2b47 !important;
        white-space: normal !important;
        width: 100% !important;
        height: 100% !important;
        outline: none !important;
        transition: all 0.2s !important;
        cursor: pointer !important;

        &:hover {
          box-shadow: 0 0 4px 0 #97aae9;
          border: 0.05rem solid #97aae9;
          color: #97aae9;
        }
      }

      .btn-disabled {
        border: 0.05rem solid #999999 !important;
        background-color: #cccccc;
        color: #666666;

        &:hover {
          // box-shadow: 0 0 4px 0 #999999;
          border: 0.05rem solid #999999 !important;
          color: #666666;
        }
      }
    }

    .buttons-select-layout {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      min-width: 260px;

      .send-selected {
        background: #f1f1f1;
        border: 1px solid #ccc;
        color: #333;
        border-radius: 4px;
        width: auto;
        font-size: 14px;
        margin: 0 5px auto;
        height: fit-content;

        &:hover,
        &:focus {
          background: rgb(247, 242, 242);
          border-color: #97aae9;
        }
      }
    }
  }

  .splide-content {
    min-height: 350px;
    padding-bottom: 50px;

    .splide__list {
      max-width: 0;
      padding: 5px !important;
    }

    .card-splide {
      width: 230px !important;
      min-height: 310px;
      box-shadow: 0 0 6px 0 #b9b8b88a;
      padding: 5px 2px;
      border-radius: 6px;
      display: flex;
      flex-direction: column;

      .img-box {
        width: 100%;
        max-height: 200px;
        transition: 1s linear;

        &:hover {
          transition: 1s linear;
          cursor: pointer;

          .select-img {
            display: flex;
            transition: 1s linear;
          }
        }
      }

      .select-img {
        display: none;
        width: 100%;
        height: 200px;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.445);
        position: absolute;
        top: 0;
        left: 0;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        color: #fff;
        font-weight: 500;
        transition: 1s linear;
      }

      .img-card {
        width: 100%;
        height: 100%;
      }

      .content {
        padding: 5px 15px;
        height: 100%;

        .title {
          font-weight: 700;
          font-size: 14px;
        }

        .description {
          font-size: 14px;
        }
      }

      .select {
        background: transparent;
        border: transparent;
        color: rgb(98, 98, 255);
        font-size: 14px;
        width: fit-content;
        margin: auto;

        &:hover {
          color: rgb(7, 7, 207);
          cursor: pointer;
        }
      }
    }

    .splide__arrows {
      .splide__arrow--prev {
        left: 0;
        top: 60%;
      }

      .splide__arrow--next {
        right: 0;
        top: 60%;
      }
    }
  }
}

.checkbox-form {
  display: flex !important;
  // justify-content: center;
  margin-top: 10px !important;
  margin-bottom: 10px !important;

  .ant-checkbox {
    margin-top: 5px;
    height: 10px;
  }
}
</style>
